import styled from "styled-components";

export const MyPageWrapper = styled.div`
   .my-page_main {
        min-height: calc(100vh - 271px);
   }
`
